import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import { saveTimetableUrl } from "./saveTimetableUrlAction";
import { IMPORT_TIMETABLE_FROM_URL_ERROR } from "../Calendar/importTimetableFromUrlAction";
import { getItem, setItem } from "../../../utils/storageHelper";

export const DELETE_TIMETABLE_SUCCESS = "api/Calendar/deleteTimetable/fulfilled";
export const DELETE_TIMETABLE_ERROR = "api/Calendar/deleteTimetable/rejected";

// The thunk will automatically generate pending, fulfilled, and rejected action types
export const deleteTimetableAction = createAsyncThunk(
    "api/Calendar/deleteTimetable",
    async (_, { dispatch, rejectWithValue }) => {
        try {
            console.log("deleting local storage in deleteTimetableAction")
            // 1. Get required data
            const calendarIds = await getItem("calendar");
            const ids = JSON.parse(calendarIds);
            const provider = await getItem('calendarProvider');
            const accessToken = await getItem('calendar_access_token');

            // 4. Dispatch action to clear the saved URL
            dispatch(saveTimetableUrl(""));
            dispatch({ type: IMPORT_TIMETABLE_FROM_URL_ERROR, payload: '' });

            console.log("Check for existing timetable ID");
            if (!ids.MyTimetable) {
                // If there's no timetable to delete, just succeed quietly.
                return { success: true, message: "No timetable found to delete." };
            }

            console.log("Axios call to delete calendar");
            // 2. Make the API call
            await axios.post(
                `${import.meta.env.VITE_PUBLIC_DOMAIN}Calendar/deleteCalendar`,
                {
                    calendarId: ids.MyTimetable,
                    accessToken: accessToken,
                    Type: provider
                }
            );

            console.log("Delete local storage for timetable");
            // 3. Update localStorage
            ids.MyTimetable = "";
            await setItem("calendar", JSON.stringify(ids));

            // 5. Return a success payload
            return { success: true };

        } catch (error) {
            // Use rejectWithValue to pass a standardized error payload
            return rejectWithValue(error.response?.data?.error || error.message);
        }
    }
);